module.exports = __webpack_public_path__ + "static/aclu-13ee44c60f9b970d235d355ed38374ee.png";